import React, { useState, useEffect } from 'react';
import axios from 'axios';

function SizeForm() {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const [sizeName, setSizeName] = useState('');
  const [sizeValue, setSizeValue] = useState('');
  const [sizes, setSizes] = useState({}); // Store sizes in a JSON object
  const [selectedSize, setSelectedSize] = useState('');
  const [selectedValue, setSelectedValue] = useState('');

  // Fetch sizes from the backend when the component mounts
  useEffect(() => {
    axios
      .get(`${baseURL}/get-sizes`, { params: { pid: 1 } }) // Replace `pid` if needed
      .then((response) => {
        setSizes(response.data);
      })
      .catch((error) => {
        console.error('Error fetching sizes:', error);
      });
  }, [baseURL]);

  // Handle adding a new size with value
  const addSize = () => {
    if (sizeName && sizeValue) {
      setSizes((prevSizes) => ({
        ...prevSizes,
        [sizeName]: sizeValue, // Dynamically add the size and value to the object
      }));
      setSizeName('');
      setSizeValue('');
    } else {
      alert('Please enter both size and value');
    }
  };

  // Handle submitting the JSON object to the backend
  const handleSubmit = () => {
    axios
      .post(`${baseURL}/add-size`, { sizes })
      .then((response) => {
        alert('Sizes added successfully!');
        // Refresh sizes after successful submission
        return axios.get(`${baseURL}/get-sizes`, { params: { pid: 1 } });
      })
      .then((response) => {
        setSizes(response.data); // Update sizes with the latest data
      })
      .catch((error) => {
        console.error('Error adding sizes:', error);
        alert('Error adding sizes');
      });
  };

  // Handle size selection
  const handleSizeChange = (e) => {
    const sizeKey = e.target.value;
    setSelectedSize(sizeKey);
    setSelectedValue(sizes[sizeKey]);
  };

  return (
    <div>
      <h3>Select Sizes and Values</h3>

      {/* Select Size */}
      <div>
        <label>Select Size: </label>
        <input
          type="text"
          value={sizeName}
          onChange={(e) => setSizeName(e.target.value)}
        />
      </div>

      {/* Size Value */}
      <div>
        <label>Enter Value: </label>
        <input
          type="text"
          value={sizeValue}
          onChange={(e) => setSizeValue(e.target.value)}
        />
      </div>

      {/* Button to add the selected size and value */}
      <button onClick={addSize}>Add Size</button>

      {/* Display the current size and value pairs */}
      <div>
        <h4>Current Sizes</h4>
        <ul>
          {Object.entries(sizes).map(([size, value], index) => (
            <li key={index}>
              {size}: {value}
            </li>
          ))}
        </ul>
      </div>

      {/* Submit all added sizes */}
      <button onClick={handleSubmit}>Submit Sizes</button>

      <hr />

      {/* Dropdown to display sizes */}
      <h3>Available Sizes</h3>
      <select onChange={handleSizeChange} value={selectedSize}>
        <option value="">Select Size</option>
        {Object.entries(sizes).map(([size, value], index) => (
          <option key={index} value={size}>
            {size}
          </option>
        ))}
      </select>

      {/* Display selected size and value */}
      {selectedSize && (
        <div>
          <p>
            <strong>Selected Size:</strong> {selectedSize}
          </p>
          <p>
            <strong>Value:</strong> {selectedValue}
          </p>
        </div>
      )}
    </div>
  );
}

export default SizeForm;
